import template from './ibanValidation.html';
import { IbanValidationController } from './ibanValidation.controller';

export const ibanValidationComponent = {
  name: 'ibanValidationComponent',
  restrict: 'E',
  template,
  transclude: true,
  controllerAs: 'vm',
  controller: IbanValidationController,
  bindings: {
    newIban: '=',
    oldIban: '=',
    onValid: '&',
  },
};
